module.exports = __webpack_public_path__ + "static/media/Coilcraft_logo.a0fe284c.gif";